import { LoginForm } from '../components/auth/LoginForm';

export const LoginPage = () => {
  const handleLogin = (data: { email: string; password: string }) => {
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      'bg-gradient-to-br from-gray-50 via-white to-gray-100'
    }`}>
      
      {/* Elementos decorativos de fondo */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-red-400/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-blue-400/5 rounded-full blur-3xl"></div>
        <div className="absolute top-3/4 left-1/2 w-48 h-48 bg-purple-400/5 rounded-full blur-2xl"></div>
      </div>
      
      {/* Contenido principal */}
      <div className="relative z-10">
        <LoginForm onSubmit={handleLogin} />
      </div>
    </div>
  );
};

export default LoginPage;